const API = process.env.REACT_APP_BACKEND_URL;

/** Fire-and-forget: count a click on any Telegram invite on the site. */
export const trackTelegramClick = (source) => {
  try {
    const body = JSON.stringify({ source, path: window.location.pathname });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/api/track/telegram-click`, new Blob([body], { type: "application/json" }));
    } else {
      fetch(`${API}/api/track/telegram-click`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
  } catch (e) { /* ignore */ }
};
